import { GoogleFreeBookingLinksSettingsUpdateHotelTypeInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { z, ZodError } from "zod";

export const googleFreeBookingLinksSettingsHotelTypeInputZodSchema =
	GoogleFreeBookingLinksSettingsUpdateHotelTypeInputSchema;

export type GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType = z.infer<
	typeof GoogleFreeBookingLinksSettingsUpdateHotelTypeInputSchema
>;

export type GoogleFreeBookingLinksSettingsZodParseErrorType =
	ZodError<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType>;
